<form class="rescoring-dialog" [formGroup]="rescoringFG" (ngSubmit)="submit()">
    <button mat-icon-button type="button" class="close-dialog-button" (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
    </button>
    <span class="dialog-title">
        Volver a realizar informe
    </span>
    <span class="dialog-description">
        Puede volver a generar el informe si desea modificar los campos principales de algún inquilino.
    </span>
    <form class="tenant-form" [formGroup]="FG" *ngFor="let FG of tenantFormGroups; let i = index">
        <span class="tenant-form-title">Inquilino {{ i + 1 }}</span>
        <div class="tenant-form-inputs">
            <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="warranty.inquilinos[i].tipoPersona === 'FISICA'">
                <mat-label>DNI</mat-label>
                <input matInput formControlName="dni" >
                <mat-error *ngIf="FG.controls.dni.hasError('required')">
                    Por favor ingrese un dni
                </mat-error>
                <mat-error *ngIf="FG.controls.dni.hasError('minlength') || FG.controls.dni.hasError('maxlength')">
                    El dni debe tener 8 dígitos
                </mat-error>
                <mat-error *ngIf="FG.controls.dni.hasError('number')">
                    El dni debe ser un número
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="warranty.inquilinos[i].tipoPersona === 'JURIDICA'">
                <mat-label>CUIT</mat-label>
                <app-cuit-input formControlName="cuit"></app-cuit-input>
                <mat-error *ngIf="FG.controls.cuit.hasError('required')">
                    Por favor ingrese un cuit
                </mat-error>
                <mat-error *ngIf="FG.controls.cuit.hasError('minlength') || FG.controls.cuit.hasError('maxlength')">
                    El cuit debe tener 11 dígitos
                </mat-error>
                <mat-error *ngIf="FG.controls.cuit.hasError('number')">
                    El cuit debe ser un número
                </mat-error>
            </mat-form-field>
            <app-sex-selector class="sex-selector-container" formControlName="sexo" *ngIf="warranty.inquilinos[i].tipoPersona === 'FISICA'"></app-sex-selector>
        </div>
    </form>
    <button mat-raised-button color="accent" class="garantor-button rescoring-button">Actualizar garantía</button>
</form>
